export default __webpack_public_path__ + "static/media/frax.9c0efaa3.svg";